import { Box, FormControl, Button, Backdrop, FormControlLabel, Grid, Radio, RadioGroup, TextField, Typography, MenuItem } from '@mui/material';
import AppLoader from '../../../components/AppLoader/AppLoader';
import FormSubmissionSuccessDialog from '../../../components/FormSubmissionSuccessDialog/FormSubmissionSuccessDialog';
import React, { useEffect, useState } from 'react';
import Select from "@mui/material/Select";

import "../../BillingAndCollection/MeterChangeRequest/MeterChangeRequestForm.scss"
import { useFormik } from 'formik';
import * as Yup from "yup";
import { cfpBaseUrl, cpBaseUrl } from '../../../network/urls';
//jspdf'
import { jsPDF } from "jspdf";
import "jspdf-autotable";
//jsbarcode
import JsBarcode from "jsbarcode";
import mepcologo from "../../../images/mepcoLogo.png";
import watermarkLowReso from "../../../images/DiscosWater/mepcco-watermark.png";
import { companyShortName, dBillAPI, subdivisionName } from '../../../services/Functions';
import Error from '../../../components/error/error';
import { damagedMeter, delayedNoMeterReading, electricFire, firstBillNotReceived, fluctuation, lineFault, liveFallenWire, lowVoltageLongTerm, lowVoltageShortTerm, mcoNotEffected, otherComplaintsArray, others, phaseIssue, portalName, powerOutage, unjustifiedDetectionBill, unjustifiedLPS } from '../../../utils/PortalName';
import { useSelector } from 'react-redux';
import FESCOLOGO from "../../../images/DISCO Logos/FESCO.png";
import GEPCOLOGO from "../../../images/DISCO Logos/GEPCO.png";
import HESCOLOGO from "../../../images/DISCO Logos/HESCO.png";
import IESCOLOGO from "../../../images/DISCO Logos/IESCO.png";
import MEPCOLOGO from "../../../images/DISCO Logos/MEPCO.png";
import LESCOLOGO from "../../../images/DISCO Logos/LESCO.png";
import PESCOLOGO from "../../../images/DISCO Logos/PESCO.png";
import QESCOLOGO from "../../../images/DISCO Logos/QESCO.png";
import SEPCOLOGO from "../../../images/DISCO Logos/SEPCO.png";
import TESCOLOGO from "../../../images/DISCO Logos/TESCO.png";
const Powercomplaintsform = () => {

  const { token, userId, code: userCode,circleCode } = useSelector((state) => state.auth)
  const [typeId, setTypeId] = React.useState(1);
  const [typeName, setTypeName] = React.useState('Power Outage')
  const [billMonth, setBillMonth] = useState("");

  const [searchBy, setSearchBy] = useState('referenceNo');
  const [latitudeOfRefNo, setLatitudeOfRefNo] = useState('')
  const [logitudeOfRefNo, setLogitudeOfRefNo] = useState('')
  const [tariff, setTariff] = useState();
  const [meterType, setMeterType] = useState();
  const [meterNo, setMeterNo] = useState();
  const [address, setAddress] = useState();
  const [phase, setPhase] = useState();
  const [error, setError] = useState();
  const [viewBackdrop, setViewBackdrop] = useState(false);
  const [powerComplaintPopUp, setPowerComplaintPopUp] = useState(false);
  const [complaintId, setComplaintId] = useState();
  const [referenceNumber, setReferenceNumber] = useState('');
  const [feederNo, setFeederNo] = useState();
  const [complaintsError, setComplaintsError] = useState("");
  const [complaintNature, setComplaintNature] = useState('')
  const TypeId = (event) => {
    setTypeId(event.target.value);
    setTypeName(event.target.name);
  };

  const initialValues = {
    // Classification group Initial Values
    iv_consumer_id: "",
    iv_name: "",
    iv_phone_no: "",
    iv_consumer_id: '',
    iv_reference_number: '',
    iv_adress: '',
  }

  const currentDate = new Date();
  const day = currentDate.getDate();
  const month = currentDate.toLocaleString('en-US', { month: 'short' }); // Get month in 'Sep' format
  const year = currentDate.getFullYear();
  const weekday = currentDate.toLocaleString('en-US', { weekday: 'short' }); // Get current weekday

  const formattedDate = `${day} ${month}, ${weekday}`;

  let subDivisionsArray = JSON.parse(
    window.localStorage.getItem("subDivisions")
  );

  const SearchBy = (event) => {
    values.iv_search_by = event.target.value;
    setSearchBy(event.target.value);
    setError('')
    setPhase()
    setAddress()
    setMeterNo()
    setMeterType()
    setTariff()
    setTypeId(1);
    values.iv_consumer_id = ''
    values.iv_reference_number = ''
    values.iv_name = ''
    values.iv_phone_no = ''
    setReferenceNumber();
  };

  const errorCloses = () => {
    setError('')
  }

  const handleClose = () => {
    setPowerComplaintPopUp(false);
    window.location.href = 'power-complaint-table';
  };

  const { values, errors, touched, handleChange, handleBlur, handleSubmit } = useFormik({
    initialValues,
    validationSchema: Yup.object({
      iv_reference_number: Yup.string().when('iv_search_by', {
        is: () => searchBy === 'referenceNo',
        then: Yup.string().min(14, 'Reference No. must be 14 digits.').max(14, 'Reference No. must be 14 digits.').required("Enter reference number."),
        otherwise: Yup.string().optional()
      }),
      iv_consumer_id: Yup.string().when('iv_search_by', {
        is: () => searchBy === 'consumerId',
        then: Yup.string().min(10, 'Customer ID. must be 10 digits.').max(10, 'Customer ID. must be 10 digits.').required("Enter consumer Id."),
        otherwise: Yup.string().optional()
      }),
      iv_name: Yup.string().min(3, "Name should be atleast 3 characters.")
        .max(30, "Name should be less than 30 characters.")
        .required("Please enter applicant name."),
      iv_adress: Yup.string().min(3, "Name should be atleast 3 characters.")
        .max(30, "Name should be less than 30 characters.")
        .required("Please enter applicant name."),
      iv_phone_no: Yup.string().max(11, "Please enter 11 digit phone number.")
        .min(11, "Please enter 11 digit phone number.")
        .required("Please enter valid mobile number.")
        .matches(/^03[0-9]{2}[0-9]{7}$/, "Enter Phone number as 03001234567"),
    }),
    onSubmit: async (values, { resetForm }) => {

      setViewBackdrop(true);

      const myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append("Authorization", token);

      const raw = JSON.stringify({
        "RefNo": referenceNumber,
        "Name": values.iv_name,
        "Mobile": values.iv_phone_no,
        "CNIC": "1234567890123",
        "Address": values.iv_adress,
        "NearByFamousPlace": values.iv_adress,
        "Province": "punjab",
        "Status": "Pending",
        "ComplaintNature": "Line Complaints",
        "Source": portalName.concat(' Commercial'),
        "ComplaintType": typeName,
        "ComplaintDescription": values.iv_con_id_complaint_details,
        "Latitude": latitudeOfRefNo ? latitudeOfRefNo : '',
        "Longitude": logitudeOfRefNo ? logitudeOfRefNo : '',
        "FeederCode": feederNo,
        "ComplaintNatureId": 1,
        "ComplaintTypeId": typeId
      });

      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow"
      };

      await fetch(cfpBaseUrl + "lineComplaints/registerLineComplain", requestOptions)
        .then(response => response.json())
        .then(result => {
          if (result.status === "200") {
            setViewBackdrop(false);
            printApplicationReceipt(result.EOpsTrackingId, values, typeName, values.iv_con_id_complaint_details);
            // const myHeaders = new Headers();
            // myHeaders.append("Authorization", token);

            // const formdata = new FormData();
            // formdata.append("refNo", referenceNumber);
            // formdata.append("EOpsTrackingId", result.TrackingId);
            // formdata.append("phoneNo", values.iv_phone_no);
            // formdata.append("name", values.iv_name);
            // formdata.append("nearest_place", address);
            // formdata.append("cat_id", "1");
            // formdata.append("type_id", typeId);

            // const requestOptions = {
            //   method: "POST",
            //   headers: myHeaders,
            //   body: formdata,
            //   redirect: "follow"
            // };

            // fetch(cfpBaseUrl + "powerComplaints/registerComplaint1", requestOptions)
            //   .then((response) => response.json())
            //   .then((result) => {

            //   })
            //   .catch(() => {});

          } else {
            setViewBackdrop(false);
            if (
              result.message ===
              "Complaint already exist against given Ref No in Same Date."
            ) {
              setComplaintsError(
                "Complaint already exist against given Ref No in Same Date."
              );
            } else {
              setComplaintsError(result.message);
            }
          }
        })
        .catch(() => {});
      setViewBackdrop(false);
    }
  });
const getLogo = (code) => {
    switch (code) {
      case '11':
        return LESCOLOGO
      case '12':
        return GEPCOLOGO
      case '13':
        return FESCOLOGO
      case '14':
        return IESCOLOGO
      case '15':
        return MEPCOLOGO
      case '26':
        return PESCOLOGO
      case '37':
        return HESCOLOGO
      case '38':
        return SEPCOLOGO
      case '48':
        return QESCOLOGO
      case '59':
        return TESCOLOGO
      default:
        return MEPCOLOGO
    }
  }
  const printApplicationReceipt = (applicationID, values, typeName, description) => {
     const doc = new jsPDF({ compressPdf: true });
 
     // Generate the barcode image using JsBarcode
     const barcodeCanvas = document.createElement("canvas");
     JsBarcode(barcodeCanvas, applicationID);
 
     // Convert the barcode image to data URL
     const barcodeDataURL = barcodeCanvas.toDataURL("image/png");
     var height = 10;
     var padding = 10;
 
     // Add the barcode image to the PDF document
     doc.addImage(barcodeDataURL, "PNG", 85, 260, 40, 20);
     const logoWidth = userCode === '12' || userCode === '13' || userCode === '11' || userCode === '16' || userCode === '27' || userCode === '48' || userCode === '59' ? 25 : 30;
     const logoHeight = userCode === '12' || userCode === '13' || userCode === '11' || userCode === '16' || userCode === '27' || userCode === '48' || userCode === '59' ? 20 : 10;
     doc.addImage(getLogo(userCode), "PNG", 90, 5, logoWidth, logoHeight);
 
     height = height + 20;
 
     var increment = 10;
     doc.setFontSize(15);
     doc.setFont("helvetica", "bold");
     doc.text(
       "Receipt of Complaint",
       doc.internal.pageSize.getWidth() / 2,
       height,
       {
         align: "center",
       }
     );
     doc.setFontSize(12);
     increment = 20;
     height = height + increment;
     var leftMargin = 120;
     doc.text("DISCO / Company: ", padding, height);
     doc.text("Sub Division Code & Name:", padding + leftMargin, height);
 
     // doc.setFont("helvetica", "normal");
     // increment = 10;
     // height = height + increment;
     // leftMargin = 120;
     // doc.text(
     //   companyShortName(circleCode.slice(0, 2)),
     //   padding,
     //   height
     // );
     // doc.text(
     //   values.iv_con_id_ref_no.slice(2,7) +
     //   " / " +
     //   subdivisionName(values.iv_con_id_ref_no.slice(2,7), subDivisionsArray),
     //   padding + leftMargin,
     //   height
     // );
 
     doc.setFont("helvetica", "normal");
     increment = 10;
     height = height + increment;
     leftMargin = 120;
     doc.text(
       companyShortName(circleCode.slice(0, 2)),
       padding,
       height
     );
     doc.text(
       values.iv_con_id_ref_no.slice(2, 7) + " / " +
       subdivisionName(values.iv_con_id_ref_no.slice(2, 7), subDivisionsArray),
       padding + leftMargin,
       height
     );
 
     increment = 10;
     height = height + increment;
     leftMargin = 40;
     doc.setFont("helvetica", "bold");
     doc.text("Tracking ID: ", padding, height);
     doc.setFont("helvetica", "normal");
     doc.text(applicationID.toString(), padding + leftMargin, height);
     leftMargin = 100;
     doc.setFont("helvetica", "bold");
 
 
     // doc.text("Applicant Name: ", padding + leftMargin, height);
     // doc.setFont("helvetica", "normal");
     // leftMargin = 150;
     // var currentDate = new Date();
     // var formattedDate = currentDate.getDate() + ' ' +
     //   ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'][currentDate.getMonth()] + ' ' +
     //   currentDate.getFullYear();
     // doc.text(formattedDate, padding + leftMargin, height);
 
 
     increment = 10;
     height = height + increment;
     leftMargin = 40;
     doc.setFont("helvetica", "bold");
     doc.text("Applicant Name: ", padding, height);
     doc.setFont("helvetica", "normal");
     doc.text(values.iv_name, padding + leftMargin, height);
     leftMargin = 100;
     doc.setFont("helvetica", "bold");
     doc.text("Applicant Mobile No.: ", padding + leftMargin, height);
     leftMargin = 150;
     doc.setFont("helvetica", "normal");
     doc.text(values.iv_phone_no, padding + leftMargin, height);
 
 
     increment = 10;
     height = height + increment;
     leftMargin = 40;
     doc.setFont("helvetica", "bold");
     doc.text("Address: ", padding, height);
     doc.setFont("helvetica", "normal");
     doc.text(values.iv_address, padding + leftMargin, height);
     let address = ""
     doc.text(address, padding + leftMargin, height);
 
 
     increment = 10;
     height = height + increment;
     leftMargin = 40;
     doc.setFont("helvetica", "bold");
     doc.text("Complaint Type: ", padding, height);
     doc.setFont("helvetica", "normal");
     doc.text(typeName, padding + leftMargin, height);
 
 
     increment = 10;
     height = height + increment;
     leftMargin = 40;
     doc.setFont("helvetica", "bold");
     doc.text("Description: ", padding, height);
     doc.setFont("helvetica", "normal");
     doc.text(description, padding + leftMargin, height);
 
 
     const totalPages = doc.internal.getNumberOfPages();
 
     if (userCode == '15') {
       for (let i = 1; i <= totalPages; i++) {
         doc.setPage(i);
         doc.addImage(
           watermarkLowReso,
           "PNG",
           0,
           0,
           doc.internal.pageSize.getWidth(),
           doc.internal.pageSize.getHeight()
         );
       }
     }
 
 
     const pdfBlob = doc.output('blob');
     const pdfDataUrl = URL.createObjectURL(pdfBlob);
 
     // Open the PDF in a new tab
     window.open(pdfDataUrl, '_blank');
 
   };

  const getCoordinates = async (refNo) => {
    var requestOptions = {
      method: 'GET',
      redirect: 'follow',
    };

    await fetch(cpBaseUrl + '?refno=' + refNo, requestOptions).then(
      response => response.json()).then(
        result => {
          if (result.tblStatus[0].status) {
            setLatitudeOfRefNo(result.Table[0].GPSLATI)
            setLogitudeOfRefNo(result.Table[0].GPSLONG)
          }
        }
      )
  }

  useEffect(() => {
    const callBillAPI = async () => {
      if (values.iv_consumer_id.length < 10) {
        setError('')
        setPhase()
        setAddress()
        setMeterNo()
        setMeterType()
        setTariff()
        setTypeId(1);
        values.iv_reference_number = ''
        values.iv_name = ''
        values.iv_phone_no = ''
        setReferenceNumber();
        return
      }
      else {
        setViewBackdrop(true)

        let apiResponse = await dBillAPI(token, values.iv_consumer_id)
        if (apiResponse.status) {
          setAddress(apiResponse.basicInfo.consumerAddress1 + " " + apiResponse.basicInfo.consumerAddress2)
          setMeterNo(apiResponse.metersInfo[0].mtrNo)
          setMeterType(apiResponse.basicInfo.meterType)
          setBillMonth(
            apiResponse.basicInfo.billMonth.slice(0, 10)
          );
          setPhase(apiResponse.basicInfo.phase)
          setFeederNo(apiResponse.basicInfo.feederCode);
          setTariff(apiResponse.basicInfo.tariffDescription)
          setReferenceNumber(apiResponse.basicInfo.refNo.replace(/ /g, "").slice(0, 14))
          values.iv_name = apiResponse.basicInfo.consumerName
          values.iv_phone_no = apiResponse.basicInfo.consumerContactNo
          values.iv_adress =
            apiResponse.basicInfo.consumerAddress1 +
            " " +
            apiResponse.basicInfo.consumerAddress2;
          getCoordinates(apiResponse.basicInfo.refNo.replace(/ /g, "").slice(0, 14))
        } else if (apiResponse.status === "400") {
          setError('No Data Found against this Customer ID.')
        }
        else {
          setError('Customer ID. not found!')
        }
        setViewBackdrop(false)
      }
    }

    callBillAPI()
  }, [values.iv_consumer_id])

  useEffect(() => {
    const callBillAPI = async () => {
      if (values.iv_reference_number.length < 14) {
        setError('')
        setPhase()
        setAddress()
        setMeterNo()
        setMeterType()
        setTariff()
        setTypeId(1);
        values.iv_consumer_id = ''
        values.iv_name = ''
        values.iv_phone_no = ''
        setReferenceNumber();
        return
      }
      else {
        setViewBackdrop(true)
        let apiResponse = await dBillAPI(token, values.iv_reference_number)
        if (apiResponse.status) {
          setAddress(apiResponse.basicInfo.consumerAddress1 + " " + apiResponse.basicInfo.consumerAddress2)
          setMeterNo(apiResponse.metersInfo[0].mtrNo)
          setMeterType(apiResponse.basicInfo.meterType)
          setPhase(apiResponse.basicInfo.phase)
          setTariff(apiResponse.basicInfo.tariffDescription)
          setReferenceNumber(apiResponse.basicInfo.refNo.replace(/ /g, "").slice(0, 14))
          values.iv_name = apiResponse.basicInfo.consumerName
          values.iv_phone_no = apiResponse.basicInfo.consumerContactNo
          values.iv_adress =
            apiResponse.basicInfo.consumerAddress1 +
            " " +
            apiResponse.basicInfo.consumerAddress2;
          getCoordinates(apiResponse.basicInfo.refNo.replace(/ /g, "").slice(0, 14))
        } 
        else if (apiResponse.status === "400") {
          setError('No Data Found against this Reference No.')
        } else {
          setError('Reference No. not found!')
        }
        setViewBackdrop(false)
      }
    }

    callBillAPI()
  }, [values.iv_reference_number])
  return (
    <>
      <Grid container className='nC'>
        <Box className='nCContainer' >
          <div className="headingBarDiv">
            <h3 className="heading">
              Complaints
            </h3>
          </div>
          <form className='ncform' >
            <Typography variant="h6" className="groupTitle">
              <div className="redCell">
              </div>
              Complaint Details
            </Typography>
            <Grid container className='container'>
              <Grid item xs={3}>
                <Typography className="fieldLabel"> Search By</Typography>
                <FormControl className="form-control"  >
                  <RadioGroup
                    className="radio-group"
                    row
                    name="iv_search_by"
                    defaultValue={searchBy}
                    value={searchBy}
                    onChange={SearchBy}
                  >
                    <FormControlLabel
                      value="referenceNo"
                      className="form-control-label"
                      control={<Radio />}
                      label="Reference No."
                      labelPlacement="end"
                    />
                    <FormControlLabel
                      value="consumerId"
                      className="form-control-label"
                      control={<Radio />}
                      label="Customer ID."
                      labelPlacement="end"
                    />
                  </RadioGroup>
                </FormControl>
              </Grid>
              {
                searchBy === 'consumerId' &&
                <Grid item lg={2} sx={{ paddingRight: '20px' }}>
                  <Typography className='fieldLabel' >Customer ID.</Typography>
                  <TextField
                    type='double'
                    name="iv_consumer_id"
                    value={values.iv_consumer_id}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    className='textInputField'
                    inputProps={{ maxLength: 10 }}
                    autoComplete='off'
                  />
                  <Box className='from-Error'>
                    {errors.iv_consumer_id && touched.iv_consumer_id ? (errors.iv_consumer_id) : null}
                  </Box>
                </Grid>
              }
              {
                searchBy === 'referenceNo' &&
                <Grid item lg={2} sx={{ paddingRight: '20px' }}>
                  <Typography className='fieldLabel' >Reference No.</Typography>
                  <TextField
                    type='double'
                    name="iv_reference_number"
                    value={values.iv_reference_number}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    className='textInputField'
                    inputProps={{ maxLength: 14 }}
                    autoComplete='off'
                  />
                  <Box className='from-Error'>
                    {errors.iv_reference_number && touched.iv_reference_number ? (errors.iv_reference_number) : null}
                  </Box>
                </Grid>
              }
              <Grid item lg={2} sx={{ paddingRight: '20px' }}>
                <Typography className='fieldLabel' >Name</Typography>
                <TextField
                  type='text'
                  name="iv_name"
                  value={values.iv_name}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  className='textInputField'
                  style={{ backgroundColor: '#f3f4f6' }}
                />
                <Box className='from-Error'>
                  {errors.iv_name && touched.iv_name ? (errors.iv_name) : null}
                </Box>
              </Grid>
              <Grid item lg={2} sx={{ paddingRight: '20px' }}>
                <Typography className='fieldLabel' >Adress</Typography>
                <TextField
                  type='text'
                  name="iv_adress"
                  value={values.iv_adress}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  className='textInputField'
                  style={{ backgroundColor: '#f3f4f6' }}
                />
                <Box className='from-Error'>
                  {errors.iv_adress && touched.iv_adress ? (errors.iv_adress) : null}
                </Box>
              </Grid>
              <Grid item lg={2} sx={{ paddingRight: '20px' }}>
                <Typography className='fieldLabel' >Phone No.</Typography>
                <TextField
                  type='text'
                  name="iv_phone_no"
                  value={values.iv_phone_no}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  className='textInputField'
                  inputProps={{ maxLength: 11 }}
                />
                <Box className='from-Error'>
                  {errors.iv_phone_no && touched.iv_phone_no ? (errors.iv_phone_no) : null}
                </Box>
              </Grid>
            </Grid>
            <Typography variant="h6" className="groupTitle">
              <div className="cyanCell">
              </div>
              Power
            </Typography>
            <Grid container className='container'>
              <Grid item lg={12}>
                <FormControl sx={{ width: '100%' }} >
                  <RadioGroup
                    sx={{
                      display: 'flex',
                      justifyContent: 'space-around',
                      alignItems: 'center',
                      width: '100%',
                      paddingLeft: '20px',
                      paddingRight: '20px',
                    }}
                    row
                    aria-labelledby="demo-form-control-label-placement"
                    name="power"
                    defaultValue="end"
                    value={typeId}
                    onChange={TypeId}
                  >
                    <Grid container >
                      <Grid item lg={3}>
                        <FormControlLabel
                          value={powerOutage}
                          control={<Radio />}
                          label="Power Outage "
                          name='Power Outage'
                          labelPlacement="end"
                          className="complaintsButton"
                        />
                      </Grid>
                      <Grid item lg={3}>
                        <FormControlLabel
                          value={damagedMeter}
                          control={<Radio />}
                          label="Damaged Meter"
                          name='Damaged Meter'
                          labelPlacement="end"
                          className="complaintsButton"

                        />
                      </Grid>
                      <Grid item lg={3}>
                        <FormControlLabel
                          value={electricFire}
                          name="Electric Fire"
                          control={<Radio />}
                          label="Electric Fire"
                          labelPlacement="end"
                          className="complaintsButton"
                        />
                      </Grid>
                      <Grid item lg={3}>
                        <FormControlLabel
                          value={fluctuation}
                          name="Fluctuation"
                          control={<Radio />}
                          label="Fluctuation"
                          labelPlacement="end"
                          className="complaintsButton"

                        />
                      </Grid>
                      <Grid item lg={3}>
                        <FormControlLabel
                          value={lineFault}
                          name="Line Fault"
                          control={<Radio />}
                          label="Line Fault"
                          labelPlacement="end"
                          className="complaintsButton"
                        />
                      </Grid>
                      <Grid item lg={3}>
                        <FormControlLabel
                          value={lowVoltageShortTerm}
                          name="Low/ High Voltage - Short Term"
                          control={<Radio />}
                          label="Low/ High Voltage - Short Term"
                          labelPlacement="end"
                          className="complaintsButton"
                        />
                      </Grid>
                      <Grid item lg={3}>
                        <FormControlLabel
                          value={lowVoltageLongTerm}
                          name="Low/ High  - Long Term"
                          control={<Radio />}
                          label="Low/ High Voltage - Long Term"
                          labelPlacement="end"
                          className="complaintsButton"
                        />
                      </Grid>
                      <Grid item lg={3}>
                        <FormControlLabel
                          value={others}
                          name="others"
                          control={<Radio />}
                          label="Others"
                          labelPlacement="end"
                          className="complaintsButton"

                        />
                      </Grid>
                    </Grid>
                  </RadioGroup>
                </FormControl>
              </Grid>
              <Grid item lg={12} sx={{ display: 'flex',margin:'1% 0' }}>
                {(typeId == 1000 || typeId == 8 || typeId == 9 || typeId == 10 || typeId == 11 || typeId == 12 || typeId == 13 || typeId == 14 || typeId == 15 || typeId == 16
                  || typeId == 17 || typeId == 18 || typeId == 19) &&
                  <Grid item xs={3} sx={{ paddingRight: '20px' }}>
                    <Typography className="fieldLabel"> Select Complaint Type</Typography>
                    <Select
                      autoWidth={false}
                      autoFocus
                      value={typeId}
                      onChange={TypeId}
                      onBlur={handleBlur}
                      displayEmpty
                      style={{ color: 'black', width: '100%', margin: "2px 2px", backgroundColor: 'white' }}
                      className="connectionTypeDropDownList"
                      id="iv_complaint_type"
                    >
                      <MenuItem value="">Select Type</MenuItem>
                      {
                        otherComplaintsArray.map((item, index) => {
                          return (
                            <MenuItem value={item.code} key={index}>{item.name}</MenuItem>
                          )
                        })
                      }
                    </Select>
                    <Box className="from-Error">
                      {errors.iv_complaint_type && touched.iv_complaint_type
                        ? errors.iv_complaint_type
                        : null}
                    </Box>
                  </Grid>
                }
                <Grid item xs={3} sx={{ paddingRight: '20px' }}>
                  <Typography className='fieldLabel' >Complaint Detail</Typography>
                  <TextField
                    type='text'
                    name="iv_con_id_complaint_details"
                    value={values.iv_con_id_complaint_details}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    className='textInputField'
                    autoComplete='off'
                    style={{ width: '100%' }}
                  />
                </Grid>
              </Grid>
            </Grid>
            <Grid container >
              <Grid item lg={12} sx={{ margin: '0px 50px 0px 25px' }}>
                {
                  complaintsError &&
                  <Error
                    error={complaintsError}
                    onClose={() => errorCloses()}
                    backgroundColor="#FFC0CB"
                    textColor="#bb0303"
                    iconColor="#bb0303"
                  />
                }
              </Grid>
            </Grid>
            {/* <Typography variant="h6" className="groupTitle">
              <div className="purpleCell">
              </div>
              Commercial
            </Typography>
            <Grid container className='form-content'>
              <Grid item lg={12}>
                <FormControl sx={{ width: '100%' }} >
                  <RadioGroup
                    sx={{
                      display: 'flex',
                      justifyContent: 'space-around',
                      alignItems: 'center',
                      width: '100%',
                      paddingLeft: '20px',
                      paddingRight: '20px',
                    }}
                    className='radio'
                    row
                    aria-labelledby="demo-form-control-label-placement"
                    name="power"
                    defaultValue="end"
                    value={typeId}
                    onChange={TypeId}
                  >
                    <Grid container >
                      <Grid item lg={4}>
                        <FormControlLabel
                          value={delayedNoMeterReading}
                          name="delayedNoMeterReading"
                          control={<Radio />}
                          label="Delayed/No Meter Reading"
                          labelPlacement="end"
                        />
                      </Grid>
                      <Grid item lg={4}>
                        <FormControlLabel
                          value={firstBillNotReceived}
                          name="firstBillNotReceived"
                          control={<Radio />}
                          label="First Bill Not Received"
                          labelPlacement="end"
                        />
                      </Grid>
                      <Grid item lg={4}>
                        <FormControlLabel
                          value={unjustifiedDetectionBill}
                          name="unjustifiedDetectionBill"
                          control={<Radio />}
                          label="Unjustified Detection Bill"
                          labelPlacement="end"
                        />
                      </Grid>
                      <Grid item lg={4}>
                        <FormControlLabel
                          value={unjustifiedLPS}
                          disabled
                          name="unjustifiedLPS"
                          control={<Radio />}
                          label="Unjustified LPS"
                          labelPlacement="end"
                        />
                      </Grid>
                      <Grid item lg={4}>
                        <FormControlLabel
                          value={mcoNotEffected}
                          disabled
                          name="mcoNotEffected"
                          control={<Radio />}
                          label="MCO Not Effected"
                          labelPlacement="end"
                        />
                      </Grid>
                    </Grid>
                  </RadioGroup>
                </FormControl>
              </Grid>
            </Grid> */}
            <Grid container >
              <Grid item lg={12} sx={{ margin: '0px 50px 0px 25px' }}>
                {
                  error &&
                  <Error
                    error={error}
                    onClose={() => errorCloses()}
                    backgroundColor="#FFC0CB"
                    textColor="#bb0303"
                    iconColor="#bb0303"
                  />
                }
              </Grid>
            </Grid>
            <Box sx={{ marginTop: "1%", textAlign: "right", marginRight: '2%', marginBottom: '2%' }}>
              <Button
                className={((values.iv_consumer_id.length === 10 || values.iv_reference_number.length === 14) && values.iv_name != '' && values.iv_phone_no.length === 11 && typeId != '') === false ? 'disabled-button' : 'button'}
                variant="contained"
                component="label"
                disabled={((values.iv_consumer_id.length === 10 || values.iv_reference_number.length === 14) && values.iv_name != '' && values.iv_phone_no.length === 11 && typeId != '') === false}
                type='submit'
                onClick={handleSubmit}
              >
                Submit
              </Button>
              {/* <Button 
              variant="contained" 
              sx={{ width: '15%' }}
               className={((values.iv_con_id_ref_no.length === 10 || values.iv_con_id_ref_no.length === 14) && values.iv_name != '' && values.iv_phone_no.length === 11 && typeId != '') === false ? 'disabled-button' : 'button'}
                component="label" 
                disabled={((values.iv_con_id_ref_no.length === 10 || values.iv_con_id_ref_no.length === 14) && values.iv_name != '' && values.iv_phone_no.length === 11 && typeId != '') === false} 
                type='submit' 
                onClick={handleSubmit}
              >Submit</Button> */}
            </Box>
          </form>
        </Box>
      </Grid >

      <FormSubmissionSuccessDialog
        open={powerComplaintPopUp}
        onClose={handleClose}
        title="Complaint submitted"
        message="Your Power complaint is submitted successfully."
        trackingId={complaintId}
        trackingLabel="Complaint ID"
      />

      {/* Backdrop */}
      < Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1000 }}
        open={viewBackdrop}
      >
        <AppLoader />
      </Backdrop >
    </>
  );
}

export default Powercomplaintsform











